import { Component, computed, input } from '@angular/core';

import { DynamicModule, InputsType } from 'ng-dynamic-component';

import { Components } from '@valk-nx/storyblok/components/reference/src/lib/reference.component';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { ISbStoryBlok } from '@valk-nx/storyblok-types/src/lib/types/storyblok.types';

@Component({
	selector: 'sb-page',
	templateUrl: './page.component.html',
	imports: [DynamicModule],
})
export class PageComponent extends StoryblokRootDirective {
	components: typeof Components = Components;

	readonly content = input.required<ISbStoryBlok[]>();
	readonly metaDescription = input.required<string>();
	readonly metaTitle = input.required<string>();

	contentInput = computed((): (InputsType & { component: string })[] => {
		return this.content().map((blok) => ({
			...blok,
			component: blok['component'] ?? '',
		}));
	});
}
